import { yupResolver } from "@hookform/resolvers/yup";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Autocomplete,
  Button,
  Card,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  Modal,
  OutlinedInput,
  Radio,
  RadioGroup,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import SnackBarUI from "../../comman/SnackBarUI";

import { singlePendingTransactionAction } from "../../redux/toolkit/pendingEarning/singlePendingTransaction";

import { pendingEarningClearAction } from "../../redux/toolkit/pendingEarning/clearPendingEarning";

// schema
const registerScbema = yup
  .object({
    user_payout: yup.string().required(),
    bonus_amt: yup.string().required(),
  })
  .required();

const ClearPending = ({ state, setState, trans_id }) => {
  let singlePendingTrans = useSelector((state) => state.singlePendingTrans);
  const {
    data: singleTransData,
    status,
    message,
    loading,
  } = singlePendingTrans;

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm({
    resolver: yupResolver(registerScbema),
    // defaultValues: {
    //     data: singleTransData
    // }
  });

  const userPayout = watch("user_payout", ""); // Default empty string
  const bonusAmount = watch("bonus_amt", "");

  const [userAmt, setUserAmt] = useState(0);
  const [bonusAmt, setBonusAmt] = useState(0);

  const dispatch = useDispatch();

  const [snack, setSnack] = useState(false);

  // fn
  const hanldeCreateAdminSupport = async () => {
    let data = {
      app_id: singleTransData[0]?.app_id,
      isPending: singleTransData[0]?.isPending,
      p_user_id: singleTransData[0]?.p_user_id,
      partner_id: singleTransData[0]?.partner_id,
      publisher_id: singleTransData[0]?.publisher_id,
      publisher_payout: singleTransData[0]?.publisher_payout,
      raw_amount: singleTransData[0]?.raw_amount,
      createdAt: singleTransData[0]?.createdAt,
      status: singleTransData[0]?.status,
      surevy_id: singleTransData[0]?.surevy_id,
      trans_id: singleTransData[0]?.trans_id,
      updatedAt: singleTransData[0]?.updatedAt,
      user_id: singleTransData[0]?.user_id,
      user_payout: singleTransData[0]?.user_payout,
      user_payout: userPayout,
      bonus_amt: bonusAmount,
    };

    const pendingClearStatus = dispatch(pendingEarningClearAction({ ...data }));

    if (pendingClearStatus?.payload?.status == 200) {
      // await dispatch(getAdminSupportAction())
      setSnack(true);
      setState(false);
    }
    setSnack(true);
    // setState(false)
  };

  useEffect(() => {
    if (singleTransData && singleTransData.length > 0) {
      reset({
        user_payout: singleTransData[0].user_payout || 0,
        bonus_amt: singleTransData[0].bonus_amt || 0,
      });
    }
  }, [singleTransData, reset]);

  const handleClose = function () {
    setState(false);
  };

  useEffect(() => {
    dispatch(singlePendingTransactionAction({ trans_id: trans_id }));
  }, [dispatch]);

  return (
    <>
      <Modal sx={{ overflow: "scroll" }} open={state} onClose={handleClose}>
        <Box className="modal_box">
          <Card sx={{ width: 600, p: 5 }}>
            <Typography variant="h5" sx={{ mb: 5 }} align="center">
              Clear Pending
            </Typography>
            <form onSubmit={handleSubmit(hanldeCreateAdminSupport)}>
              {/* 
                             <TextField
                        InputLabelProps={{ shrink: true }}
                        label="App logo"
                        type="file"
                        id="app_logo"
                        {...register("app_logo")}
                        onChange={handleIconUpload}
                        error={errors?.app_logo?.message}
                        helperText={errors?.app_logo?.message}
                        style={{ width: "100%" }}
                      /> */}

              <Stack spacing={3}>
                <Stack spacing={2}>
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    label="User Payout"
                    variant="outlined"
                    placeholder="User Payout"
                    {...register("user_payout")}
                    onChange={(e) => setValue("user_payout", e.target.value)}
                    error={errors?.user_payout?.message}
                    helperText={errors?.user_payout?.message}
                  />
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    label="Bonus Amount"
                    variant="outlined"
                    placeholder="bonus_amt"
                    {...register("bonus_amt")}
                    onChange={(e) => setValue("bonus_amt", e.target.value)}
                    error={errors?.bonus_amt?.message}
                    helperText={errors?.bonus_amt?.message}
                  />
                </Stack>

                <Stack direction={"row"} spacing={2}>
                  <Button variant="contained" type="submit" disabled={loading}>
                    {loading ? <CircularProgress /> : "Clear Pending"}
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => setState(false)}
                  >
                    {" "}
                    Close
                  </Button>
                </Stack>
              </Stack>
            </form>
          </Card>
        </Box>
      </Modal>
      <SnackBarUI
        state={snack}
        setState={setSnack}
        status={status}
        message={message}
      />
    </>
  );
};

export default ClearPending;
